import { useEffect, useState } from 'react';

export function useResendCooldown(initialValue = 0) {
    const [resendCooldown, setResendCooldown] = useState(initialValue);

    useEffect(() => {
        if (resendCooldown <= 0) {
            return;
        }

        const timer = setTimeout(() => {
            setResendCooldown((currentValue) => Math.max(currentValue - 1, 0));
        }, 1000);

        return () => clearTimeout(timer);
    }, [resendCooldown]);

    return {
        resendCooldown,
        setResendCooldown,
        startResendCooldown: (seconds: number) => setResendCooldown(Math.max(seconds, 0)),
    };
}
